module.exports = __webpack_public_path__ + "static/media/eye.eb7d3a5b.svg";